import { Project } from '@brg/api';
import { Colors, FInter, FlexBox, HintTooltip, MEDIA, Skeleton, useBreakpoint } from '@brg/ui';
import { LayoutConst } from 'core';
import { FC, ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';

import { ApplicationTheme, ApplicationThemeT } from 'shared/themes';
import styled, { css, ThemeProvider } from 'styled-components';
import ProjectButtons from '../components/ProjectButtons';
import ProjectHeader, { ProjectHeaderRoot } from '../components/ProjectHeader';
import { bProfile, useProfile } from '@brg/auth';
import { executeTypograf } from 'shared/utils/executeTypograf';
import { BTagsGridNew } from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { useGetFriendlyUrlParam } from 'shared/hooks/useGetFriendlyUrlParam';
import { getFormattedDate } from 'shared/helpers/getFormattedDate';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { getProjectAiSummary } from 'shared/helpers/getProjectAiSummary';
import { AiSummarySparkIcon } from '../components/AiSummarySparkIcon';

export const DEFAULT_VIEW_TYPE = 'container';
const CREATED_AT_FEATURE_RELEASE_DATE = new Date('2026-03-17');

//todo убрать отступы на иконках, перевести на gap
export const ProjectBottomActionsWrapper = styled(FlexBox) <{
  isModer?: boolean,
  viewType?: string,
  hasAiSummary?: boolean,
}>`
  width: 100%;
  flex-flow: column;
  // margin: 24px auto 0;
  margin: 0 auto;
  justify-content: center;
  place-items: center;
  background: #fff;
  padding: 24px 48px;
  //border-radius: 4px;
  max-width: 1152px;

  ${ProjectHeaderRoot} {
    margin-top: 0;
    width: 100%;
    text-align: center;
    * {
      color: rgba(0,0,0,0.47);
    }
    .ProjectHeaderMadeBy {
      color: #151514;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      padding-right: 0;
    }
  }

  ${({ hasAiSummary }) => hasAiSummary && css`
    ${ProjectHeaderRoot} {
      margin-bottom: 0;
    }
  `}

  .buttons-wrapper > div {
    margin-bottom: 0;
    &:not(:last-of-type) {
        margin-right: 24px;
    }

    svg path {
      fill: rgba(0,0,0,0.47);
    }

    svg:hover path {
      fill: ${Colors.galBlack100};
    }
    .count-icon-wrapper svg:hover path {
      fill: rgba(0,0,0,0.47);
    }
    .project-tools-send svg:hover path {
      fill: ${Colors.galBlack100}!important;
    }
    padding: 0;
    order: 0;
     @media(max-width: ${LayoutConst.screen.mac13}px) {
        &:not(:last-of-type) {
            margin-right: 16px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        &:not(:last-of-type) {
            margin-left: 0;
            margin-right: 8px;
        }
    }
  }

  .LikesButtonWrapper, .ViewsCountWrapper {
    max-width: fit-content !important;
  }

  .likes-icon-wrapper {
    flex-direction: row !important;
    place-items: center;
    display: flex;
    gap: 2px;
  }

  .likes-icon-wrapper > span {
    margin-left: 8px;
    margin-top: 0;
    font-size: 11px;
    line-height: 13px;
    color: rgba(0,0,0,0.47);

    @media(max-width: ${LayoutConst.screen.sm}px) {
        margin: 0;
    }
  }

  .count-icon-wrapper {
    flex-direction: row !important;
    place-items: center;
    display: flex;
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-direction: column !important;
    }
  }

  .count-icon-wrapper span {
    margin-left: 8px;
    margin-top: 2px;
    color: rgba(0,0,0,0.47);
    @media(max-width: ${LayoutConst.screen.sm}px) {
        margin: 0;
    }
  }

  .ps-action-btn {
    padding: 0 !important;
    margin-bottom: 0;
  }
  .ps-action-moder-btn {
    padding: 0;
  }

  .approval-dialog-wrap {
    margin-top: 32px;
  }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    padding: 24px 40px;

      width: 888px;

      .approval-dialog-wrap {
        margin-top: 32px;
      }
      }

    @media(max-width: ${LayoutConst.screen.md}px) {
      padding: 16px 32px;
      margin: 0 auto;
      width: calc(100% - 32px);
    }
  
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      padding: 16px;
      margin-top: 8px;

      .approval-dialog-wrap {
        margin-top: 32px;
      }
    }
`;


const Title = styled(FInter.MainTitleMediumDiv) <{ hseFonts?: boolean }>`
  font-size: 30px;
  line-height: 40px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: #151514;
  text-align: center;

  @media (max-width: 834px) {
    font-size: 22px;
    line-height: 28px;
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    font-size: 17px;
    line-height: 22px;
  }

  .MoreButtonWrapper {
    align-items: flex-start;
  }
`;

const aiSummaryTypography = css`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  text-align: center;
  color: #909090;
  width: 100%;
`;

const AiSummarySection = styled(FlexBox)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 24px;
  gap: 8px;
`;

const AiSummaryText = styled.div`
  ${aiSummaryTypography}
  max-width: 564px;
  margin: 0 auto;

  @media (max-width: ${LayoutConst.screen.l}px) {
    max-width: 500px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: 500px) {
    max-width: 100%;
  }
`;

const AiSummaryDisclaimer = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0;
  text-transform: uppercase;
  text-align: center;
  color: #909090;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  svg path {
    fill: #909090;
  }
`;

const CreatedAt = styled.div`
  color: ${({ theme }) => theme.text?.label};
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  margin-top: 8px;
  user-select: none;

  @media ${MEDIA.LAPTOP} {
    font-size: 11px;
    line-height: 13px;
  }
`;

const formatDate = (date: string, includeTime: boolean = false) => {
  return moment(date).format('DD.MM.YYYY HH:mm');
}

export const PSBottomActions: FC<{
  theme: ApplicationThemeT,
  project: Project,
  titleVisible: boolean,
  isEmptyProjectTags?: boolean,
  isPresentationTooltip?: boolean,
  isLoading?: boolean,
  tags: ReactNode;
  tagsCount: number;
  approveDialog: ReactNode;
}> = ({
  isLoading,
  theme,
  isPresentationTooltip,
  project,
  isEmptyProjectTags,
  titleVisible = true,
  tags,
  tagsCount,
  approveDialog
}) => {
    const { t, i18n } = useTranslation();
    const id = useGetFriendlyUrlParam("id");
    const projectIdRef = useRef<{ id: string }>(null);
    const [collapseTags, setCollapseTags] = useState(false);
    const isPreview = !!useRouteMatch(['/preview', '/books/book-preview']);
    const profile = useProfile();
    const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
    const is940 = useBreakpoint(LayoutConst.screen.md);
    const is743 = useBreakpoint(LayoutConst.screen.s - 1)
    //@ts-ignore
    const editedTitle = project?.additionalContent?.title?.text

    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])
    const viewType = useMemo(() => (project?.longread?.viewType || DEFAULT_VIEW_TYPE), [project])

    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

    const maxTagHeight = (isMac13 || smHeight) ? 140 : 162;

    //@ts-ignore
    projectIdRef.current = id;

    useEffect(() => {
      setTimeout(() => {
        //@ts-ignore
        if (projectIdRef.current === id) {
          const tagsContainer = document.querySelector('#tags_bottom_container');
          if (tagsContainer) {
            //@ts-ignore
            if (tagsContainer.offsetHeight > maxTagHeight) {
              setCollapseTags(true);
            }
          }
        }
      }, 100)

    }, [projectIdRef, id, maxTagHeight]);

    const createdAt = useMemo(() => {
      if (project?.created && new Date(project?.created) < CREATED_AT_FEATURE_RELEASE_DATE
        && project?.approvals?.[0]?.date > project?.published) {
        return project?.approvals?.[0]?.date || project?.published;
      }
      return project?.published;
    }, [project?.created]);

    const shouldDisplayEditedAt = project?.edited > createdAt;

    const formattedCreatedAt = useMemo(() => {
      if (createdAt) {
        return formatDate(createdAt);
      }
      return null;
    }, [createdAt]);

    const fromattedEditedAt = useMemo(() => {
      if (project?.edited) {
        return formatDate(project?.edited);
      }
      return null;
    }, [project?.edited]);

    const aiSummaryText = useMemo(
      () => getProjectAiSummary((project as { aiSummary?: unknown })?.aiSummary, i18n.language),
      [project, i18n.language],
    );

    const tagsGridMarginTop = aiSummaryText ? 24 : (is940 ? 16 : 0);

    if (isPreview) {
      return null;
    }

    const createdAtHint = useMemo(() => {
      return `${t("project.created_at")} ${formattedCreatedAt}. ${shouldDisplayEditedAt ? `${t("project.edited_at")} ${fromattedEditedAt}` : ''}`;
    }, [t, formattedCreatedAt, fromattedEditedAt]);

    if (!project) {
      return (
        <ProjectBottomActionsWrapper viewType={viewType} hasAiSummary={false}>
          <Skeleton width={'100%'} height={'154px'} />
        </ProjectBottomActionsWrapper>
      )
    }

    return (
      <ProjectBottomActionsWrapper isModer={isModer} viewType={viewType} hasAiSummary={Boolean(aiSummaryText)}>
        {titleVisible && (
          <>
            <Title>{executeTypograf(editedTitle || project?.title || 'untitled')}</Title>
            <FlexBox offsetTop={8} offsetTopMobile={0} offsetLeftMobile={10} offsetRightMobile={10} widthMobile={'100%'}>
              <ProjectHeader project={project} variant="bottom" />
            </FlexBox>
            {aiSummaryText && (
              <AiSummarySection>
                <AiSummaryText>{aiSummaryText}</AiSummaryText>
                <AiSummaryDisclaimer>
                  {t('project.ai_summary_disclaimer')}
                  <AiSummarySparkIcon />
                </AiSummaryDisclaimer>
              </AiSummarySection>
            )}
          </>
        )}
        <ThemeProvider theme={ApplicationTheme.white as any}>
          {Boolean(tagsCount) && <BTagsGridNew style={{ marginTop: tagsGridMarginTop }} id="tags_bottom_container" scrollMode="all" shadow justify="center">
            {tags}
          </BTagsGridNew>}
        </ThemeProvider>
        <FlexBox offsetTop={Boolean(tagsCount) ? 22 : 10} offsetTopMobile={titleVisible ? is743 ? 24 : 14 : 0}>
          <ProjectButtons dropdownVerticalPos={"top"} project={project} orientation='horizontal' dropdownPos={'right'} isBottomTooltip={true} isPresentationTooltip={isPresentationTooltip} />
        </FlexBox>
        {approveDialog &&
          <FlexBox>
            {approveDialog}
          </FlexBox>
        }
        {createdAt && (
          <HintTooltip
            text={createdAtHint}
            noArrow
            customStyle={{
              ...tooptipStylesWhite,
              transform: 'translateX(-25%)'
            }}
            offsetY={4}
            positionY='top'
            z={1000}
          >
            <CreatedAt>
              {t("project.created_at")} {moment(createdAt).format('DD.MM.YYYY')}
            </CreatedAt>
          </HintTooltip>
        )}
      </ProjectBottomActionsWrapper>
    )
  }import { Project } from '@brg/api';
import { Colors, FInter, FlexBox, HintTooltip, MEDIA, Skeleton, useBreakpoint } from '@brg/ui';
import { LayoutConst } from 'core';
import { FC, ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';

import { ApplicationTheme, ApplicationThemeT } from 'shared/themes';
import styled, { css, ThemeProvider } from 'styled-components';
import ProjectButtons from '../components/ProjectButtons';
import ProjectHeader, { ProjectHeaderRoot } from '../components/ProjectHeader';
import { bProfile, useProfile } from '@brg/auth';
import { executeTypograf } from 'shared/utils/executeTypograf';
import { BTagsGridNew } from "../../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import { useGetFriendlyUrlParam } from 'shared/hooks/useGetFriendlyUrlParam';
import { getFormattedDate } from 'shared/helpers/getFormattedDate';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { getProjectAiSummary } from 'shared/helpers/getProjectAiSummary';
import { AiSummarySparkIcon } from '../components/AiSummarySparkIcon';

export const DEFAULT_VIEW_TYPE = 'container';
const CREATED_AT_FEATURE_RELEASE_DATE = new Date('2026-03-17');

//todo убрать отступы на иконках, перевести на gap
export const ProjectBottomActionsWrapper = styled(FlexBox) <{
  isModer?: boolean,
  viewType?: string,
  hasAiSummary?: boolean,
}>`
  width: 100%;
  flex-flow: column;
  // margin: 24px auto 0;
  margin: 0 auto;
  justify-content: center;
  place-items: center;
  background: #fff;
  padding: 24px 48px;
  //border-radius: 4px;
  max-width: 1152px;

  ${ProjectHeaderRoot} {
    margin-top: 0;
    width: 100%;
    text-align: center;
    * {
      color: rgba(0,0,0,0.47);
    }
    .ProjectHeaderMadeBy {
      color: #151514;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      padding-right: 0;
    }
  }

  ${({ hasAiSummary }) => hasAiSummary && css`
    ${ProjectHeaderRoot} {
      margin-bottom: 0;
    }
  `}

  .buttons-wrapper > div {
    margin-bottom: 0;
    &:not(:last-of-type) {
        margin-right: 24px;
    }

    svg path {
      fill: rgba(0,0,0,0.47);
    }

    svg:hover path {
      fill: ${Colors.galBlack100};
    }
    .count-icon-wrapper svg:hover path {
      fill: rgba(0,0,0,0.47);
    }
    .project-tools-send svg:hover path {
      fill: ${Colors.galBlack100}!important;
    }
    padding: 0;
    order: 0;
     @media(max-width: ${LayoutConst.screen.mac13}px) {
        &:not(:last-of-type) {
            margin-right: 16px;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        &:not(:last-of-type) {
            margin-left: 0;
            margin-right: 8px;
        }
    }
  }

  .LikesButtonWrapper, .ViewsCountWrapper {
    max-width: fit-content !important;
  }

  .likes-icon-wrapper {
    flex-direction: row !important;
    place-items: center;
    display: flex;
    gap: 2px;
  }

  .likes-icon-wrapper > span {
    margin-left: 8px;
    margin-top: 0;
    font-size: 11px;
    line-height: 13px;
    color: rgba(0,0,0,0.47);

    @media(max-width: ${LayoutConst.screen.sm}px) {
        margin: 0;
    }
  }

  .count-icon-wrapper {
    flex-direction: row !important;
    place-items: center;
    display: flex;
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-direction: column !important;
    }
  }

  .count-icon-wrapper span {
    margin-left: 8px;
    margin-top: 2px;
    color: rgba(0,0,0,0.47);
    @media(max-width: ${LayoutConst.screen.sm}px) {
        margin: 0;
    }
  }

  .ps-action-btn {
    padding: 0 !important;
    margin-bottom: 0;
  }
  .ps-action-moder-btn {
    padding: 0;
  }

  .approval-dialog-wrap {
    margin-top: 32px;
  }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    padding: 24px 40px;

      width: 888px;

      .approval-dialog-wrap {
        margin-top: 32px;
      }
      }

    @media(max-width: ${LayoutConst.screen.md}px) {
      padding: 16px 32px;
      margin: 0 auto;
      width: calc(100% - 32px);
    }
  
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      padding: 16px;
      margin-top: 8px;

      .approval-dialog-wrap {
        margin-top: 32px;
      }
    }
`;


const Title = styled(FInter.MainTitleMediumDiv) <{ hseFonts?: boolean }>`
  font-size: 30px;
  line-height: 40px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: #151514;
  text-align: center;

  @media (max-width: 834px) {
    font-size: 22px;
    line-height: 28px;
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    font-size: 17px;
    line-height: 22px;
  }

  .MoreButtonWrapper {
    align-items: flex-start;
  }
`;

const aiSummaryTypography = css`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  text-align: center;
  color: #909090;
  width: 100%;
`;

const AiSummarySection = styled(FlexBox)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 24px;
  gap: 8px;
`;

const AiSummaryText = styled.div`
  ${aiSummaryTypography}
  max-width: 564px;
  margin: 0 auto;

  @media (max-width: ${LayoutConst.screen.l}px) {
    max-width: 500px;
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: 500px) {
    max-width: 100%;
  }
`;

const AiSummaryDisclaimer = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0;
  text-transform: uppercase;
  text-align: center;
  color: #909090;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  svg path {
    fill: #909090;
  }
`;

const CreatedAt = styled.div`
  color: ${({ theme }) => theme.text?.label};
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  margin-top: 8px;
  user-select: none;

  @media ${MEDIA.LAPTOP} {
    font-size: 11px;
    line-height: 13px;
  }
`;

const formatDate = (date: string, includeTime: boolean = false) => {
  return moment(date).format('DD.MM.YYYY HH:mm');
}

export const PSBottomActions: FC<{
  theme: ApplicationThemeT,
  project: Project,
  titleVisible: boolean,
  isEmptyProjectTags?: boolean,
  isPresentationTooltip?: boolean,
  isLoading?: boolean,
  tags: ReactNode;
  tagsCount: number;
  approveDialog: ReactNode;
}> = ({
  isLoading,
  theme,
  isPresentationTooltip,
  project,
  isEmptyProjectTags,
  titleVisible = true,
  tags,
  tagsCount,
  approveDialog
}) => {
    const { t, i18n } = useTranslation();
    const id = useGetFriendlyUrlParam("id");
    const projectIdRef = useRef<{ id: string }>(null);
    const [collapseTags, setCollapseTags] = useState(false);
    const isPreview = !!useRouteMatch(['/preview', '/books/book-preview']);
    const profile = useProfile();
    const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
    const is940 = useBreakpoint(LayoutConst.screen.md);
    const is743 = useBreakpoint(LayoutConst.screen.s - 1)
    //@ts-ignore
    const editedTitle = project?.additionalContent?.title?.text

    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), [])
    const viewType = useMemo(() => (project?.longread?.viewType || DEFAULT_VIEW_TYPE), [project])

    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);

    const maxTagHeight = (isMac13 || smHeight) ? 140 : 162;

    //@ts-ignore
    projectIdRef.current = id;

    useEffect(() => {
      setTimeout(() => {
        //@ts-ignore
        if (projectIdRef.current === id) {
          const tagsContainer = document.querySelector('#tags_bottom_container');
          if (tagsContainer) {
            //@ts-ignore
            if (tagsContainer.offsetHeight > maxTagHeight) {
              setCollapseTags(true);
            }
          }
        }
      }, 100)

    }, [projectIdRef, id, maxTagHeight]);

    const createdAt = useMemo(() => {
      if (project?.created && new Date(project?.created) < CREATED_AT_FEATURE_RELEASE_DATE
        && project?.approvals?.[0]?.date > project?.published) {
        return project?.approvals?.[0]?.date || project?.published;
      }
      return project?.published;
    }, [project?.created]);

    const shouldDisplayEditedAt = project?.edited > createdAt;

    const formattedCreatedAt = useMemo(() => {
      if (createdAt) {
        return formatDate(createdAt);
      }
      return null;
    }, [createdAt]);

    const fromattedEditedAt = useMemo(() => {
      if (project?.edited) {
        return formatDate(project?.edited);
      }
      return null;
    }, [project?.edited]);

    const aiSummaryText = useMemo(
      () => getProjectAiSummary((project as { aiSummary?: unknown })?.aiSummary, i18n.language),
      [project, i18n.language],
    );

    const tagsGridMarginTop = aiSummaryText ? 24 : (is940 ? 16 : 0);

    if (isPreview) {
      return null;
    }

    const createdAtHint = useMemo(() => {
      return `${t("project.created_at")} ${formattedCreatedAt}. ${shouldDisplayEditedAt ? `${t("project.edited_at")} ${fromattedEditedAt}` : ''}`;
    }, [t, formattedCreatedAt, fromattedEditedAt]);

    if (!project) {
      return (
        <ProjectBottomActionsWrapper viewType={viewType} hasAiSummary={false}>
          <Skeleton width={'100%'} height={'154px'} />
        </ProjectBottomActionsWrapper>
      )
    }

    return (
      <ProjectBottomActionsWrapper isModer={isModer} viewType={viewType} hasAiSummary={Boolean(aiSummaryText)}>
        {titleVisible && (
          <>
            <Title>{executeTypograf(editedTitle || project?.title || 'untitled')}</Title>
            <FlexBox offsetTop={8} offsetTopMobile={0} offsetLeftMobile={10} offsetRightMobile={10} widthMobile={'100%'}>
              <ProjectHeader project={project} variant="bottom" />
            </FlexBox>
            {aiSummaryText && (
              <AiSummarySection>
                <AiSummaryText>{aiSummaryText}</AiSummaryText>
                <AiSummaryDisclaimer>
                  {t('project.ai_summary_disclaimer')}
                  <AiSummarySparkIcon />
                </AiSummaryDisclaimer>
              </AiSummarySection>
            )}
          </>
        )}
        <ThemeProvider theme={ApplicationTheme.white as any}>
          {Boolean(tagsCount) && <BTagsGridNew style={{ marginTop: tagsGridMarginTop }} id="tags_bottom_container" scrollMode="all" shadow justify="center">
            {tags}
          </BTagsGridNew>}
        </ThemeProvider>
        <FlexBox offsetTop={Boolean(tagsCount) ? 22 : 10} offsetTopMobile={titleVisible ? is743 ? 24 : 14 : 0}>
          <ProjectButtons dropdownVerticalPos={"top"} project={project} orientation='horizontal' dropdownPos={'right'} isBottomTooltip={true} isPresentationTooltip={isPresentationTooltip} />
        </FlexBox>
        {approveDialog &&
          <FlexBox>
            {approveDialog}
          </FlexBox>
        }
        {createdAt && (
          <HintTooltip
            text={createdAtHint}
            noArrow
            customStyle={{
              ...tooptipStylesWhite,
              transform: 'translateX(-25%)'
            }}
            offsetY={4}
            positionY='top'
            z={1000}
          >
            <CreatedAt>
              {t("project.created_at")} {moment(createdAt).format('DD.MM.YYYY')}
            </CreatedAt>
          </HintTooltip>
        )}
      </ProjectBottomActionsWrapper>
    )
  }